// extracted by mini-css-extract-plugin
export default {"container":"naRgL6","container--dark":"sqWkbF mz-dark-mode"};